import { patchUrlByLocale } from 'utils';
import { navigate } from './utils';
import { State } from 'store/types';
import { StoreonDispatch } from 'storeon';
import { SearchHistoryItem } from '../use-search-history-context';
import { ProductRedirectionEvents } from 'actions';

export const handleLmCode = (
  productRedirectionUrl: string | null | undefined,
  dispatch: StoreonDispatch<State>,
  setIsSubmitted: React.Dispatch<React.SetStateAction<boolean>>,
  collapse: () => void,
  addHistoryItem: (item: SearchHistoryItem) => void,
  value: string,
  sanitizedValue: string,
) => {
  const url = productRedirectionUrl ?? `/search/?q=${sanitizedValue}`;
  const patchedUrl = patchUrlByLocale({
    url,
  });
  navigate(patchedUrl);
  setIsSubmitted(false);
  collapse();
  addHistoryItem({ title: value, url: patchedUrl });
  if (productRedirectionUrl) {
    dispatch(ProductRedirectionEvents.refresh);
  }
};
